<template>
  <div id="LayListVideo">
    <div class="left_Title">
      <p>
        <i class="iconfont iconjieguo"></i>
        <span class="aqt_lang_mn titlefont">{{ $t('m.seareturn') + '&nbsp;' + '(' + total + ')'  |U2M }}</span>
      </p>
      <p></p>
    </div>

    <div v-if="!isNo" class="list_Content aqt_su" ref="Content_Width">
      <div class="aqt_list_lists_one" v-for="(item,index) in list" :key="index"
           @click="getDetail(item.videos_id,$crypto.get($route.query.pid))"
           :style="{marginBottom:(index+1)%5!=0?'15px':'0px',width:boxWidth+'px'}">
        <div class="aqt_top aqt_ce_ve">
          <img class="videoimg"
               v-lazy="item.img?$webcrypto.get(item.img):''" alt/>
          <div class="login">
            <img src="@/assets/images/play.png" alt/>
          </div>
          <div class="time aqt_no_su" v-if="item.voratime">{{ item.voratime }}</div>
          <div v-if="item.titlelang&&item.titlelang.mn &&item.isshowtitle==1" class="mtitle aqt_lang_mn titlefont">
            {{ item.titlelang.mn | U2M }}
          </div>

        </div>

        <div class="aqt_bottom aqt_no_su">
          <div class="data ">
            <i :style="{fontSize:'0.8rem'}" class="iconfont iconliulanjilusel"></i>&nbsp;{{ item.count }}
          </div>
          <div class="size">{{ $fileSizeTransformation(item.size) }}</div>
        </div>
      </div>
      <div style="clear: both"></div>
    </div>

    <div class="page">
      <PageMn v-if="!isNo" :total="total" :current="current_page"
              :pageSize="per_page" @getPager="getPager">
        </PageMn>
      <!-- <Page v-if="!isNo" :total="total" :current="current_page"
            :page-size="per_page" 
            @on-change="getPager"/> -->
    </div>
    <div v-if="isNo&&!list.length" class="nomassage">
      <p class="aqt_lang_mn titlefont">{{ $t('m.noData') | U2M }}</p>
    </div>

    <!--    加载动画-->
    <AqtSpin v-if="isSpin"></AqtSpin>
  </div>
</template>

<script>
export default {
  data() {
    return {
      total: 0,
      current_page: 1,
      per_page: 0,
      list: [],
      isNo: false,
      isSpin: false,
      query:{
        page: 1,
        per_page: '',
        pid:this.$crypto.get(this.$route.query.pid),
        lang:'mn',
        library_id:28,
        library_num:'1586741202'
      },
      boxWidth:''
    }
  },
  methods: {
    getList() {
      let that = this
      that.isNo = false
      that.isSpin = true
      let cond = {
        pid: that.$crypto.get(that.$route.query.pid)
      }
      that.$httpsencrypt.post(`api/web/v3/videos/list`, that.query)
          .then((val) => {
            if (val.code == 200 && val.data.length) {
              that.list = val.data
              that.total = val.pages.total
              that.current_page = val.pages.current_page
              that.per_page = val.pages.per_page * 1
              that.isSpin = false
              that.isNo = false
            } else {
              that.list = []
              thst.isNo = true
              that.isSpin = false
              that.total = 0
            }

          }).catch(e => {
            that.list = []
            that.isNo = true
            that.isSpin = false
            that.total = 0
          }
      )
    },
    getDetail(id, pid) {
      this.$router.push({
        path: '/VideoFrequencyListDetails',
        query: {
          lib_type:sessionStorage.getItem('gcm'),
          id: this.$crypto.set(id),
          pid: this.$crypto.set(pid)
        }
      })
    },
    getPager(page) {
      let that = this
      that.list = []
      that.query.page = page
      that.getList()
    },
  },
  mounted() {
    let that = this
    let tt = that.$refs.Content_Width.clientHeight
    let boxHeight = (tt-60)/5
    that.boxWidth= Math.floor(boxHeight*1.208)

    let kk = that.$refs.Content_Width.clientWidth / (that.boxWidth +15)

    that.query.per_page = Math.floor(kk) * 5
    that.query.page = 1
    that.list = []
    this.getList()
  },
  created() {
    let info={
      type: 40,
      path: this.$route.path,
      mark: '视频列表',
    }
    this.$store.dispatch('saveUserBehavior', info).then(() => {
    })
  }
}
</script>

<style lang="less" scoped>
#LayListVideo {
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;


  .contentfonts1 {
    font-size: 1.6rem;
  }

  .nomassage {
    padding: 0 1rem;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: center;
    display: -ms-flexbox;
    display: flex;
    font-size: 2rem;
    color: #888888;
  }

  .left_Title {
    width: 54px;
    height: 100%;
    background: #ffffff;
    margin-right: 2px;
    padding-top: 27px;
    display: flex;
    justify-content: flex-end;


    p:nth-child(1) {
      width: 24px;
      color: var(--themeColor);
      font-size: 20px;
      line-height: 24px;

      i {
        font-size: 24px;

      }
    }

    p:nth-child(2) {
      width: 8px;
      height: 162px;
      background: var(--themeColor);
      margin-left: 10px;
    }
  }

  .list_Content {
    width: 100%;
    height: 100%;
    overflow-x: auto !important;
    overflow-y: hidden;

    .aqt_list_lists_one {
      width: 193px;
      //width: 21vh;
      height: calc(calc(100% - 60px) / 5);
      background-color: #ffffff;
      cursor: pointer;
      //border: 2px solid var(--themeColor);
      border-radius: 6px;
      margin-right: 15px;
      margin-bottom: 15px;
      float: left;
      display: flex;
      justify-content: center;
      align-items: center;

      .aqt_top {
        width: 100%;
        height: calc(100% - 3rem);
        overflow: hidden;
        position: relative;
        border-radius: 0.5rem 0.5rem 0rem 0rem;

        .login {
          top: calc(50% - 2.5rem);
          left: calc(50% - 2.5rem);
          position: absolute;

          img {
            width: 5rem;
          }
        }

        .time {
          position: absolute;
          bottom: 5px;
          right: 5px;
          padding: 5px;
          background-color: rgba(0, 0, 0, .5);
          color: #fff;
          border-radius: 10px 10px 10px 10px;
          font-size: 1rem;
        }

        .mtitle {
          top: 0;
          left: 0;
          height: 100%;
          line-height: 2.5rem;
          max-width: 10rem;
          text-align: center;
          //padding: 0.5rem 0.6rem 0.5rem 0.6rem;
          padding: 0.5rem 0rem 0.5rem 0rem;
          font-size: 1.6rem;
          color: #ffffff;
          background-color: rgba(56, 53, 53, 0.3);
          position: absolute;
          border-radius: 0.3rem 0rem 0rem 0rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 4;
        }

        .videoimg {
          width: 100%;
          height: 100%;
          border-radius: 0.5rem 0.5rem 0rem 0rem;
        }

        img[lazy="loading"] {
          height: auto !important;
        }
      }

      .aqt_bottom {
        width: 100%;
        height: 3rem;
        display: flex;
        -webkit-justify-content: space-between;
        justify-content: space-between;
        padding: 0.5rem 1rem 0rem 0.5rem;
        font-size: 1.7rem;

        .data {
          font-size: 1rem;
          color: #888;
          padding: 0 1rem 0.5rem 0;
        }

        .size {
          font-size: 1rem;
          color: #888;
        }
      }

    }

    .aqt_list_lists_one:hover {
      opacity: 0.8;
    }
  }

  .list_Content::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 8px;
  }

  .list_Content::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .list_Content::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }

  .page {
    width: 50px;
    height: 100%;
  }

}
</style>
<style lang="less">
#LayListVideo {
  .ivu-tooltip-popper {
    max-height: 250px !important;

    .ivu-tooltip-inner {
      width: 100%;
      white-space: pre-line !important;

      p {
        white-space: pre-line !important;
      }
    }
  }

}

</style>
